import { EventHandlerBase } from "pytha2";

interface NeedRedrawAxisNet {
    uuid: string
    elevation: number
}

/**
 * 修改轴网图元标高
 */
export class EventHandlerUpdateAxisNetElevation extends EventHandlerBase {


    /**
     * 处理器默认运行入口
     * @param data 
     * @returns 
     */
    run(data = {}) {
        const needRedrawAxisNet: NeedRedrawAxisNet[] = this.node.graph.cache.inputObject['AXISNETS'];
        // 没有则不处理
        if (needRedrawAxisNet?.length === 0) return true;

        needRedrawAxisNet.forEach(item => {
            let pri = this.getPythaStorage()?.primitiveStore.primitiveDict[item.uuid];
            if (pri) {
                pri.localModelMatrix.elements[14] = item.elevation;
                pri.updateWorldModelMatrix();
                pri.needRedraw = true;
            }
        })
        return true;
    }
}